// Supported interview languages. Must stay in sync with the enum in
// ElementAI-BE/models/InterviewModel.js and ai_interview_bot/languages.py.
export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "es", label: "Español (Spanish)" },
  { value: "fr", label: "Français (French)" },
  { value: "de", label: "Deutsch (German)" },
  { value: "pt", label: "Português (Portuguese)" },
  { value: "it", label: "Italiano (Italian)" },
  { value: "hi", label: "हिन्दी (Hindi)" },
  { value: "ar", label: "العربية (Arabic)" },
  { value: "zh", label: "中文 (Mandarin)" },
  { value: "ja", label: "日本語 (Japanese)" },
  { value: "ko", label: "한국어 (Korean)" },
  { value: "ru", label: "Русский (Russian)" },
];
